"use strict";
import { styled, Text } from "ui/src";
export var BadgeVariant = /* @__PURE__ */ ((BadgeVariant2) => {
  BadgeVariant2["WARNING"] = "WARNING";
  BadgeVariant2["SOFT"] = "SOFT";
  return BadgeVariant2;
})(BadgeVariant || {});
const Badge = styled(Text, {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "$spacing2",
  py: "$spacing2",
  px: "$spacing6",
  justifyContent: "center",
  backgroundColor: "$surface3",
  fontWeight: "500",
  color: "$neutral2",
  variant: "body3",
  variants: {
    badgeVariant: {
      ["SOFT" /* SOFT */]: { backgroundColor: "$greenVibrantLight", color: "$neutral2Temp" },
      ["WARNING" /* WARNING */]: { backgroundColor: "$statusWarning", color: "$surface1" }
    },
    size: {
      small: {
        variant: "body4"
      }
    },
    placement: {
      start: {
        borderTopLeftRadius: "$rounded4",
        borderBottomLeftRadius: "$rounded4"
      },
      middle: {},
      end: {
        borderTopRightRadius: "$rounded4",
        borderBottomRightRadius: "$rounded4"
      },
      only: {
        borderRadius: "$rounded4"
      }
    }
  }
});
export default Badge;
